module.exports = __webpack_public_path__ + "static/img/banner-personal.13c09b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-personal.jpg
// module id = RQiw
// module chunks = 21